export function propsToInitialState(data, chuyenMucList) {
  const dataInit = { ...data };
  dataInit.hienThi = data?.hienThi === false ? false : true;
  dataInit.tin_NoiBat = data?.tin_NoiBat || false;
  dataInit.chuyenMuc =
    chuyenMucList?.find(item => item?.id === data?.idChuyenMuc) || null;
  dataInit.fileImages = data?.anhDaiDien?.file_path
    ? [
        {
          bucket_name: data.anhDaiDien?.bucket_name || null,
          file_path: data.anhDaiDien?.file_path || null,
          file_oid: data.anhDaiDien?.file_oid || 0,
          file_name: data.anhDaiDien?.file_name || null,
          file_ext: data.anhDaiDien?.file_ext || null,
          file_size: data.anhDaiDien?.file_size || 0
        }
      ]
    : null;
  return dataInit;
}

export function parseDataSave(value) {
  const dataSave = { ...value };
  dataSave.idChuyenMuc = value?.chuyenMuc?.id || 0;
  dataSave.tin_NoiBat = value?.tin_NoiBat || false;
  dataSave.hienThi = value?.hienThi || false;
  dataSave.anhDaiDien = value?.fileImages?.[0]?.file_path
    ? value?.fileImages?.[0]
    : null;
  return dataSave;
}
